/**
 * Product ID to Stripe Price ID mappings
 * Source: checkout/src/app/modules/checkout/register/register.ctrl.js
 */
export const PRODUCT_TO_PRICE_ID: Record<string, string> = {
  // PDF2XL Home (Monthly & Yearly)
  'pdf2xl-home-monthly': 'pdf2xl_home_monthly_usd',
  'pdf2xl-home-yearly': 'pdf2xl_home_yearly_usd_180',

  // PDF2XL Business (Monthly & Yearly)
  'pdf2xl-business-monthly': 'pdf2xl_business_monthly_usd',
  'pdf2xl-business-yearly': 'pdf2xl_business_yearly_usd_300',

  // PDF2XL Enterprise (Monthly & Yearly)
  'pdf2xl-enterprise-monthly': 'pdf2xl_enterprise_monthly_usd',
  'pdf2xl-enterprise-yearly': 'pdf2xl_enterprise_yearly_usd_420',

  // PDF2XL Pro (Perpetual License)
  'pdf2xl-pro-perpetual': 'pdf2xl_pro_perpetual_usd_499',

  // PDF2Word Home (Perpetual License)
  'pdf2word-home-perpetual': 'pdf2word_home_perpetual_usd',
};

/**
 * Product display names
 */
export const PRODUCT_NAMES: Record<string, string> = {
  'pdf2xl-home-monthly': 'PDF2XL Home - Monthly',
  'pdf2xl-home-yearly': 'PDF2XL Home - Yearly',
  'pdf2xl-business-monthly': 'PDF2XL Business - Monthly',
  'pdf2xl-business-yearly': 'PDF2XL Business - Yearly',
  'pdf2xl-enterprise-monthly': 'PDF2XL Enterprise - Monthly',
  'pdf2xl-enterprise-yearly': 'PDF2XL Enterprise - Yearly',
  'pdf2xl-pro-perpetual': 'PDF2XL Pro - Perpetual License',
  'pdf2word-home-perpetual': 'PDF2Word Home - Perpetual License',
};

/**
 * Product types
 */
export const ProductType = {
  SUBSCRIPTION: 'subscription',
  PERPETUAL: 'perpetual',
} as const;

/**
 * Check if product is a subscription
 */
export const isSubscriptionProduct = (productId: string): boolean => {
  return productId.includes('monthly') || productId.includes('yearly');
};

/**
 * Check if product is perpetual
 */
export const isPerpetualProduct = (productId: string): boolean => {
  return productId.includes('perpetual');
};

/**
 * Get product tier from product ID
 */
export const getProductTier = (
  productId: string
): 'home' | 'business' | 'enterprise' | 'pro' | 'unknown' => {
  if (productId.includes('home')) return 'home';
  if (productId.includes('business')) return 'business';
  if (productId.includes('enterprise')) return 'enterprise';
  if (productId.includes('pro')) return 'pro';
  return 'unknown';
};

/**
 * Stripe publishable key (should be set via environment variable)
 */
export const STRIPE_PUBLISHABLE_KEY =
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ||
  'pk_test_your_publishable_key_here';

/**
 * Application URLs
 */
export const APP_URLS = {
  SUCCESS: '/purchase/thanks',
  CANCEL: '/purchase/cart',
  HOME: 'https://www.cogniview.com',
};
